<template>
    <el-dialog title="País de uso, explotación o aprovechamiento del servicio"
               :visible="showDialog" @open="create" @close="close"
               :close-on-click-modal="false" width="30%">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <div class="form-group">
                    <label class="control-label">País<span class="text-danger"> *</span></label>
                    <el-select v-model="country_id" filterable>
                        <el-option v-for="option in countries" :key="option.id" :value="option.id"
                                   :label="`${option.id} - ${option.description}`"></el-option>
                    </el-select>
                </div>
                <div class="form-actions text-right mt-4">
                    <el-button @click.prevent="close()">Cancelar</el-button>
                    <el-button type="primary" native-type="submit">Guardar</el-button>
                </div>
            </div>
        </form>
    </el-dialog>
</template>

<script>
    export default {
        props: ['showDialog', 'countries', 'serviceCountryId'],
        data() {
            return {
                country_id: null,
            }
        },
        methods: {
            create() {
                this.country_id = this.serviceCountryId
            },
            submit() {
                if (!this.country_id)
                    return this.$message.error('Debe seleccionar el país de uso, explotación o aprovechamiento del servicio')

                this.$emit('addServiceCountry', this.country_id)
                this.$emit('update:showDialog', false)
            },
            close() {
                this.$emit('update:showDialog', false)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/documents/partials/service_country.vue